import Services from './services';
const services = new Services();
const apiUrl = "https://leixiaotui.com/admin/api";

// login
export const login = params => services.post(`${apiUrl}/signin`, params);

// 用户
export const usersConfig = {
  add: params => services.post(`${apiUrl}/users`, params, { withAuth: true }),
  query: params => services.get(`${apiUrl}/users`, params, { withAuth: true }),
  update: params => services.put(`${apiUrl}/users`, params, { withAuth: true }),
  delete: params =>
    services.delete(`${apiUrl}/users/${params.id}`, { withAuth: true }),
  queryOne: params =>
    services.get(`${apiUrl}/users/${params.username}`, { withAuth: true })
};

/**
 *  菜单相关
 * */

export const menuConfig = {
  query: params =>
    services.get(`${apiUrl}/menuConfig`, params, { withAuth: true }),
  add: params =>
    services.post(`${apiUrl}/menuConfig`, params, { withAuth: true }),
  update: params =>
    services.put(`${apiUrl}/menuConfig`, params, { withAuth: true }),
  delete: params =>
    services.delete(`${apiUrl}/menuConfig/${params.id}`, { withAuth: true }),
  queryOne: params =>
    services.get(`${apiUrl}/menuConfig/${params.id}`, { withAuth: true })
};

//新闻中心api
export const news = {
  query: params => services.get(`${apiUrl}/news`, params, { withAuth: true }),
  add: params => services.post(`${apiUrl}/news`, params, { withAuth: true }),
  update: params => services.put(`${apiUrl}/news`, params, { withAuth: true }),
  delete: params =>
    services.delete(`${apiUrl}/news/${params.id}`, { withAuth: true }),
  queryOne: params =>
    services.get(`${apiUrl}/news/${params.id}`, {}, { withAuth: true })
};

//相册api
export const album = {
  query: params => services.get(`${apiUrl}/album`, params, { withAuth: true }),
  add: params => services.post(`${apiUrl}/album`, params, { withAuth: true }),
  update: params => services.put(`${apiUrl}/album`, params, { withAuth: true }),
  delete: params =>
    services.delete(`${apiUrl}/album/${params.id}`, { withAuth: true }),
  queryOne: params =>
    services.get(`${apiUrl}/album/${params.id}`, {}, { withAuth: true })
};

//单页管理api
export const singlePages = {
  query: params =>
    services.get(`${apiUrl}/singlePages`, params, { withAuth: true }),
  add: params =>
    services.post(`${apiUrl}/singlePages`, params, { withAuth: true }),
  update: params =>
    services.put(`${apiUrl}/singlePages`, params, { withAuth: true }),
  delete: params =>
    services.delete(`${apiUrl}/singlePages/${params.id}`, { withAuth: true }),
  queryOne: params =>
    services.get(`${apiUrl}/singlePages/${params.id}`, {}, { withAuth: true })
};

//site管理api
export const site = {
  query: params => services.get(`${apiUrl}/site`, params, { withAuth: true }),
  add: params => services.post(`${apiUrl}/site`, params, { withAuth: true }),
  update: params => services.put(`${apiUrl}/site`, params, { withAuth: true }),
  delete: params =>
    services.delete(`${apiUrl}/site/${params.id}`, { withAuth: true }),
  queryOne: params =>
    services.get(`${apiUrl}/site/${params.id}`, {}, { withAuth: true })
};

// indexInfo管理api
export const indexInfo = {
  update: params =>
    services.put(`${apiUrl}/indexInfo`, params, { withAuth: true }),
  queryOne: params =>
    services.get(`${apiUrl}/indexInfo/${params.id}`, {}, { withAuth: true })
};

//广告管理api
export const ads = {
  query: params => services.get(`${apiUrl}/ads`, params, { withAuth: true }),
  add: params => services.post(`${apiUrl}/ads`, params, { withAuth: true }),
  update: params => services.put(`${apiUrl}/ads`, params, { withAuth: true }),
  delete: params =>
    services.delete(`${apiUrl}/ads/${params.id}`, { withAuth: true }),
  queryOne: params =>
    services.get(`${apiUrl}/ads/${params.id}`, {}, { withAuth: true })
};

//图片管理api
export const pictures = {
  query: params =>
    services.get(`${apiUrl}/pictures`, params, { withAuth: true }),
  add: params =>
    services.post(`${apiUrl}/pictures`, params, { withAuth: true }),
  update: params =>
    services.put(`${apiUrl}/pictures`, params, { withAuth: true }),
  delete: params =>
    services.delete(`${apiUrl}/pictures/${params.id}`, { withAuth: true }),
  queryOne: params =>
    services.get(`${apiUrl}/pictures/${params.id}`, {}, { withAuth: true })
};

export default {
  login: login,
  usersConfig: usersConfig,
  menuConfig: menuConfig,
  news: news,
  singlePages: singlePages,
  album: album,
  site: site,
  indexInfo: indexInfo,
  ads: ads,
  pictures: pictures
};
